<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/cataloge-mapping/user" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditUserCatalogue") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.UserName')"
              >
                <vs-input
                  :label="$t('setup.label.UserName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="teamData.username"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Catalogue")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Catalogue')"
                >
                  <v-select
                    label="name"
                    multiple
                    :options="teamById.availableCatalog"
                    v-model="teamData.selectedCatalog"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updateUserCataloge"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const teamEmptyObj = {
  locale: "en",

  salesCatalogeDetails: [],
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      teamData: teamEmptyObj,
      data: {},
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      teamById: (state) => state.catalogueMapping.EditViewUserCatalogeList,
    }),
  },
  methods: {
    async editViewUserCataloge() {
      try {
        await this.$store.dispatch(
          "catalogueMapping/seteditViewUserCataloge",
          this.id
        );
        this.teamData = this.teamById;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateUserCataloge() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        this.teamData.salesCatalogeDetails = [];
        for (let temp of this.teamData.selectedCatalog) {
          this.teamData.salesCatalogeDetails.push(temp.id);
        }

        this.teamData.locale = "en";
        delete this.teamData.id;
        delete this.teamData.username;
        delete this.teamData.availableCatalog;
        delete this.teamData.appUserDatas;
        delete this.teamData.selectedCatalog;

        await this.$store.dispatch(
          "catalogueMapping/updateUserCatalogeAction",
          {
            id: this.id,
            data: this.teamData,
          }
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "User Cataloge Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/cataloge-mapping/user`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },

    resetForm() {
      this.teamData = teamEmptyObj;
    },
    cancel() {
      this.$router.push(`/setup/cataloge-mapping/user`);
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.editViewUserCataloge();
  },
};
</script>
